<template>
  <span
    :class="computed_class"
    :style="computed_style"
    ref="googleIcon"
    aria-hidden="true"
  >
    {{ icon }}
  </span>
</template>

<script>
import "material-symbols";

export default {
  name: "GoogleSymbols",
  props: {
    variant: {
      type: String,
      default: "outlined",
      validator: (value) => ["outlined", "rounded", "sharp"].includes(value)
    },
    fill: { type: Boolean, default: false },
    icon: { type: String, required: true },
    color: { type: String, default: "#000000" },
    weight: { type: [String, Number], default: 400 },
    grad: { type: [String, Number], default: 0 },
    opsz: { type: [String, Number], default: 48 },
    size: { type: [String, Number], default: "24px" }
  },
  computed: {
    computed_class() {
      return `material-symbols-${this.variant}`;
    },
    computed_style() {
      return {
        color: this.color,
        "font-variation-settings": `'FILL' ${this.fill ? 1 : 0}, 'wght' ${
          this.weight
        }, 'GRAD' ${this.grad}, 'opsz' ${this.opsz}`,
        fontSize: `${this.size}`
      };
    }
  },
  watch: {
    color(newColor) {
      this.$refs.googleIcon.style.color = newColor;
    }
  }
};
</script>

<style scoped></style>
